var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"moveDiv",staticClass:"xuanfu",style:({width:_vm.itemWidth+'px',height:_vm.itemHeight+'px',left:_vm.left+'px',top:_vm.top+'px'}),attrs:{"id":"moveDiv"},on:{"mousedown":_vm.down,"touchstart":_vm.down,"mousemove":_vm.move,"touchmove":_vm.move,"mouseup":_vm.end,"touchend":_vm.end,"click":_vm.onBtnClicked}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6edbbfbc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/float.vue
// module id = null
// module chunks = 